import { Input, Select } from 'antd'
import Card from 'components/card/Card'
import { IconSearch } from 'components/icons'
import Errors from 'components/errors/Errors'
import Pagination from 'components/pagination/Pagination'
import OrdersTable from './OrdersTable'
import {
  EcommerceProductTypeEnum,
  OrderDirectionEnum,
  OrderOperationSortFieldEnum,
  OrdersListOperationResponseItem,
  SaleOrderStatusEnum,
} from 'generated/api'
import { DropDownSaleOrderStatus } from 'constants/dropdown'

interface PropsOrderDetail {
  isLoading: boolean
  isFailed: boolean
  orders: OrdersListOperationResponseItem[]
  tableType: EcommerceProductTypeEnum
  totalRows: number
  currentLimit: number
  currentPage: number
  inputSearch: string
  selectedStatus: SaleOrderStatusEnum
  sortDirection: OrderDirectionEnum
  sortField: OrderOperationSortFieldEnum
  onChangeInputSearch: (value: string) => void
  onChangeSelectedStatus: (value: SaleOrderStatusEnum) => void
  onSearchOrder: () => void
  onFetchOrder: () => void
  onSelectOrder: (order: OrdersListOperationResponseItem) => void
  onChangeSort: (value: OrderOperationSortFieldEnum) => void
  onChangeCurrentPage: (value: number) => void
  onChangeCurrentLimit: (value: number) => void
}

export default function OrdersIndex(props: PropsOrderDetail) {
  const {
    isLoading,
    isFailed,
    orders,
    tableType,
    totalRows,
    currentLimit,
    currentPage,
    inputSearch,
    selectedStatus,
    sortDirection,
    sortField,
    onChangeInputSearch,
    onChangeSelectedStatus,
    onSearchOrder,
    onFetchOrder,
    onSelectOrder,
    onChangeSort,
    onChangeCurrentPage,
    onChangeCurrentLimit,
  } = props

  return (
    <Card
      loading={isLoading}
      dataTestId="card_orders"
      spinnerTestId="loader_orders"
      className="rounded-xl p-0 pb-2"
    >
      <Card.Header className="sticky-card-header block py-2 px-4 rounded-t-xl">
        <div className="block xl:flex xl:h-12">
          <div className="xl:w-2/5 w-full"></div>
          <div className="xl:w-3/5 w-full">
            <div className="xl:flex xl:flex-row xl:gap-4 h-full">
              <div className="xl:w-3/5 mb-4 xl:mb-0">
                <Input
                  suffix={<IconSearch />}
                  className="input-search"
                  style={{ height: 40 }}
                  data-testid="input_search_order"
                  placeholder="Masukan Nomor Pesanan"
                  disabled={isLoading}
                  value={inputSearch}
                  onChange={e => onChangeInputSearch(e.target.value)}
                  onPressEnter={onSearchOrder}
                />
              </div>
              <div className="xl:w-2/5 mb-4 xl:mb-0">
                <Select
                  data-testid="select_order_status"
                  value={selectedStatus}
                  className="dropdown-search"
                  style={{ height: 40 }}
                  onChange={(val: SaleOrderStatusEnum) => onChangeSelectedStatus(val)}
                >
                  {DropDownSaleOrderStatus.map(status => {
                    return (
                      <Select.Option
                        data-testid={`select_sale_order_status_${status.value}`}
                        key={status.value}
                        value={status.value}
                      >
                        {status.label}
                      </Select.Option>
                    )
                  })}
                </Select>
              </div>
            </div>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="mt-0">
        {isFailed ? (
          <Errors
            data-testid="error_message_orders"
            inverse={false}
            header="Mohon maaf, permintaan Anda tidak dapat diproses."
            paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
            button={true}
            buttonLabel="Coba lagi"
            buttonAction={() => onFetchOrder()}
          />
        ) : (
          <OrdersTable
            loading={false}
            data={orders}
            type={tableType}
            selectOrder={payload => onSelectOrder(payload)}
            orderDirection={sortDirection}
            orderColumn={sortField}
            setSortingOrder={(field: OrderOperationSortFieldEnum) => onChangeSort(field)}
          />
        )}
      </Card.Body>
      {totalRows > 10 && (
        <Card.Footer>
          <div className="px-4 py-3">
            <Pagination
              disabled={isLoading}
              setLimit={(limit: number) => onChangeCurrentLimit(limit)}
              onPageChanged={(page: number) => onChangeCurrentPage(page)}
              totalRows={totalRows}
              currentPage={currentPage}
              limit={currentLimit}
              showLimitPage={true}
            />
          </div>
        </Card.Footer>
      )}
    </Card>
  )
}
